import {
  DomUtil,
  DataQuery,
  DomEventListener,
  PaletteFactory,
  ColorPaletteEnum,
  RGBA,
  DBxEvent
} from "cartovista";
import ServiceAreasResultsList from "./ServiceAreasResultsList";
import MapTarget from "../../mapTools/MapTarget";
import { serviceAreas } from "../../utils/ServerRequests";
import {  createFeatures,  createDataRows} from "../../utils/CvUtils";
import {show} from "../../appTools/Alerts";
import { Popover } from 'bootstrap';
import "../../../css/ServiceAreas.css";﻿

const responsiveBtn = '<span id="cv-responsiveBtnServiceAreasView"></span>';
const responsiveViewContainer = '<div id="cv-responsiveServiceAreasView" class="cv-responsiveViewContainer"></div>';
const genericView = '<div data-cv-role="genericView" id="ServiceAreas_panel" data-cv-active="false" data-cv-responsiveTarget="cv-responsiveServiceAreasView"></div>';
const btnToggleGenericView = '<button data-cv-role="btnToggleGenericView" id="ServiceAreas_panel_btn" data-cv-toggleGroup="topSidebarGroup" data-cv-associatedContainer="ServiceAreas_panel" data-cv-responsiveTarget="cv-responsiveBtnServiceAreasView" title="Zones de desserte: générer des zones de desserte à partir du réseau routier"></button>';

const sourceTypePopoverHtml = '<p>Le paramètre <strong><em>Sources</em></strong> spécifie la ou les sources à partir desquelles les zones de desserte sont générées. Deux options sont disponibles:' +
                                        '<ul style=\'margin-left:20px;\'>' +
                                            '<li><strong><em>Point dans la carte</em></strong>: utilisez l\'outil de cible pour pointer une source directement sur la carte. Cliquez sur le bouton cible, puis cliquez sur la carte à l\'emplacement voulu. Cette option permet de définir une seule source par requête.</li>' +
                                            '<li><strong><em>Entités sélectionnées</em></strong>: utilisez les entités ponctuelles (points) sélectionnées comme sources. Vous devez au préalable utiliser les outils de sélections disponibles dans la barre d\'outils de la carte. Cette option permet de définir plusieurs sources par requête.</li>' +
                                        '</ul>' +
                                    '</p>';

    const breakValuesInputPopoverHtml = '<p>Le paramètre <strong><em>Valeurs des bornes</em></strong> spécifie le nombre et la taille des zones de desserte générées pour chaque source. Les unités des bornes sont définies par le paramètre <strong><em>Unités</em></strong></p>' +
                                        '<p>Ce paramètre doit être constitué d\'une liste de nombres entiers séparés par une virgule.';

    const breaksUnitInputPopoverHtml = '<p>Le paramètre <strong><em>Unités des bornes</em></strong> spécifie les unités des bornes qui peuvent être en distance ou en temps de conduite.</p>';

    const polygonesParametersPopoverHtml = '<p>Si plusieurs entités ponctuelles (points) sont sélectionnées, les zones de desserte peuvent êtres générées avec les paramètres suivants:' +
                                                '<ul style=\'margin-left:20px;\'>' +
                                                    '<li><strong><em>Fusionnées</em></strong>: les zones de desserte qui se superposent sont fusionnées en une seule zone.</li>' +
                                                    '<li><strong><em>Sans superposition</em></strong>: les portions des zones de desserte qui se superposent sont tronquées.</li>' +
                                                    '<li><strong><em>Superposées</em></strong>: les zones de desserte ne sont ni fusionnées ni tronquées et peuvent se superposer.</li>' +
                                                '</ul>' +
                                            '</p>' +
                                            '<p>Si plusieurs bornes ont été spécifiées, les zones de desserte peuvent être générées avec les paramètres suivants:' +
                                                '<ul style=\'margin-left:20px;\'>' +
                                                    '<li><strong><em>Anneaux</em></strong>: pour chaque borne, une zone de desserte est générée à partir de la borne précédente.</li>' +
                                                    '<li><strong><em>Disques</em></strong>: pour chaque borne, une zone de desserte est générée à partir de la source.</li>' +
                                                '</ul>' +
                                            '</p>';

    const travelModeInputPopoverHtml = '<p>Le paramètre <strong><em>Mode de transport</em></strong> spécifie le moyen utilisé afin de se déplacer.  Une voiture se doit de respecter les routes à sens unique, alors qu\'un piéton n\'est pas obligé de le faire.</p>';

    const traversiersChkPopoverHtml = '<p>Le paramètre <strong><em>Éviter les traversiers saisonniers</em></strong> ne permet pas l\'utilisation des traversiers saisonniers afin de se déplacer.  Voici la liste des traversiers saisonniers:' +
                                          '<ul style=\'margin-left:20px;\'>' +
                                              '<li><em>Dorval/Île-Dorval</em></li>' +
                                              '<li><em>Harrington Harbour/Chevery</em></li>' +
                                              '<li><em>Harrington Harbour/Tête-à-la-Baleine</em></li>' +
                                              '<li><em>Havre-Saint-Pierre/Natashquan</em></li>' +
                                              '<li><em>Hudson/Oka</em></li>' +
                                              '<li><em>Kegaska/La Romaine</em></li>' +
                                              '<li><em>L\'Île-Bizard/Laval-sur-le-Lac</em></li>' +
                                              '<li><em>La Romaine/Harrington Harbour</em></li>' +
                                              '<li><em>La Tabatière/Saint-Augustin</em></li>' +
                                              '<li><em>Lefaivre/Montebello</em></li>' +
                                              '<li><em>Montmagny/L\'Isle-aux-Grues</em></li>' +
                                              '<li><em>Montréal (été)/Gaspé - Îles-de-la-Madeleine</em></li>' +
                                              '<li><em>Natashquan/Kegaska</em></li>' +
                                              '<li><em>Notre-Dame-des-Sept-Douleurs/L\'Isle-Verte</em></li>' +
                                              '<li><em>Notre-Dame-du-Lac/Saint-Juste-du-Lac</em></li>' +
                                              '<li><em>Pointe-Fortune/Carillon</em></li>' +
                                              '<li><em>Port-Menier/Havre-Saint-Pierre</em></li>' +
                                              '<li><em>Quyon/Fitzroy Harbour</em></li>' +
                                              '<li><em>Rimouski/Forestville</em></li>' +
                                              '<li><em>Rimouski/Sept-Îles</em></li>' +
                                              '<li><em>Saint-Antoine-sur-Richelieu/Saint-Denis</em></li>' +
                                              '<li><em>Saint-Augustin/Blanc-Sablon</em></li>' +
                                              '<li><em>Saint-Augustin/Pointe-à-la-Truite</em></li>' +
                                              '<li><em>Saint-Marc-sur-Richelieu/Saint-Charles-sur-Richelieu</em></li>' +
                                              '<li><em>Saint-Paul-de-l\'Île-aux-Noix/Fort Lennox</em></li>' +
                                              '<li><em>Saint-Roch-de-Richelieu/Saint-Ours</em></li>' +
                                              '<li><em>Saint-Siméon/Rivière-du-Loup</em></li>' +
                                              '<li><em>Sainte-Barbe T.-N.-et-Labrador/Blanc-Sablon</em></li>' +
                                              '<li><em>Sept-Îles/Port-Menier</em></li>' +
                                              '<li><em>Tête-à-la-Baleine/La Tabatière</em></li>' +
                                              '<li><em>Trois-Pistoles/Les Escoumins</em></li>' +
                                          '</ul>' +
                                      '</p>';

    const serviceAreasContainerHtml = '<div id="ServiceAreas_container">' +
                                            '<ul class="nav nav-tabs" role="tablist">' +
                                                '<li class="nav-item" role="presentation"><a class="nav-link active" href="#ServiceAreas_requestTab" aria-controls="ServiceAreas_requestTab" role="tab" data-bs-toggle="tab">Requête</a></li>' +
                                                '<li class="nav-item" role="presentation"><a class="nav-link" href="#ServiceAreas_resultsTab" aria-controls="ServiceAreas_resultsTab" role="tab" data-bs-toggle="tab">Résultats&nbsp;<span id="ServiceAreas_resultsCount"></span></a></li>' +
                                            '</ul>' +
                                            '<div class="tab-content">' +
                                                '<div role="tabpanel" class="tab-pane active" id="ServiceAreas_requestTab">' +
                                                    '<h5>' +
                                                        '<strong>Création de zones de desserte</strong>' +
                                                        '<br><small><em>Veuillez paramétrer votre requête en utilisant le formulaire ci-dessous, puis cliquez sur Soumettre.</em></small>' +
                                                    '</h5>' +
                                                    '<form id="ServiceAreas_form" role="form">' +
                                                        '<div class="form-group">' +
                                                            '<label for="ServiceAreas_sourceTypeInput" class="form-label">Sources</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Sources" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + sourceTypePopoverHtml + '">?</a>)' +
                                                            '<div style="display:inline-table; width:100%;">' +
                                                                '<select id="ServiceAreas_sourceTypeInput" class="form-select form-control" style="display:table-cell;">' +
                                                                    '<option value="MAP_TARGET">Point dans la carte</option>' +
                                                                    '<option value="SELECTION">Entités sélectionnées</option>' +
                                                                '</select>' +
                                                                '<div style="display:table-cell; width:0; vertical-align:top;">' +
                                                                    '<a id="ServiceAreas_mapTargetBtn" class="btn btn-primary" href="javascript:void(0)" data-cv-radioGroup="mapTools" type="button" tabindex="-1" title="Cible: Définir la source en pointant un emplacement sur la carte"></a>' +
                                                                '</div>' +
                                                            '</div>' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<label for="ServiceAreas_travelModeInput" class="form-label">Mode de transport</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Mode de transport" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + travelModeInputPopoverHtml + '">?</a>)' +
                                                            '<select id="ServiceAreas_travelModeInput" class="form-select form-control">' +
                                                                '<option value="WALK">Piéton</option>' +
                                                                '<option value="CAR" selected>Voiture</option>' +
                                                            '</select>' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<input class="form-check-input" type="checkbox" id="ServiceAreas_chkTraversiers" style="margin-top: 0px;">' +
                                                            '<label class="form-check-label form-label" style="padding-left: 5px;" for="ServiceAreas_chkTraversiers">Éviter les traversiers saisonniers</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Éviter les traversiers saisonniers" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + traversiersChkPopoverHtml + '">?</a>)' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<label for="ServiceAreas_breakValuesInput" class="form-label">Valeurs des bornes</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Valeurs des bornes" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + breakValuesInputPopoverHtml + '">?</a>)' +
                                                            '<input type="text" id="ServiceAreas_breakValuesInput" class="form-control", placeholder="ex.: 30, 50"></input>' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<label for="ServiceAreas_breaksUnitInput" class="form-label">Unités des bornes</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Unités des bornes" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + breaksUnitInputPopoverHtml + '">?</a>)' +
                                                            '<select id="ServiceAreas_breaksUnitInput" class="form-select form-control">' +
                                                                '<optgroup id="DISTANCE" label="Unités de distance">' +
                                                                    '<option value="Meters" name="mètre">Mètres</option>' +
                                                                    // '<option value="Kilometers" name="kilomètre" selected>Kilomètres</option>' +
                                                                    // '<option value="Feet" name="pied">Pieds</option>' +
                                                                    // '<option value="Miles" name="mile">Miles</option>' +
                                                                '</optgroup>' +
                                                                '<optgroup id="TIME" label="Unités de temps de conduite">' +
                                                                    // '<option value="Seconds" name="seconde">Secondes</option>' +
                                                                    '<option value="Minutes" name="minute">Minutes</option>' +
                                                                    // '<option value="Hours" name="heure">Heures</option>' +
                                                                '</optgroup>' +
                                                            '</select>' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<label for="ServiceAreas_polygonForMultipleFacilitiesInput" class="form-label">Types de polygones en sortie</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Types de polygones en sortie" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + polygonesParametersPopoverHtml + '">?</a>)' +
                                                            '<select id="ServiceAreas_polygonForMultipleFacilitiesInput" class="form-select form-control" disabled="true">' +
                                                                '<option value="DISSOLVE">Fusionnées</option>' +
                                                                '<option value="SPLIT">Sans superposition</option>' +
                                                                '<option value="OVERLAP">Superposées</option>' +
                                                            '</select>' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<select id="ServiceAreas_polygonOverlapTypeInput" class="form-select form-control" disabled="true">' +
                                                                '<option value="RINGS">Anneaux</option>' +
                                                                '<option value="DISKS">Disques</option>' +
                                                            '</select>' +
                                                        '</div>' +
                                                        '<div class="form-group">' +
                                                            '<label for="ServiceAreas_colorPaletteMenu" class="form-label">Palettes de couleurs</label>' +
                                                            '<br>' +
                                                            '<a id="ServiceAreas_colorPaletteBtn" href="javascript:void(0);" class="btn btn-outline-secondary"></a>' +
                                                        '</div>' +
                                                        '<div class="d-grid justify-content-md-end">' +
                                                          '<button type="submit" id="ServiceAreas_submitBtn" class="btn btn-primary">Soumettre</button>'+
                                                        '</div>'+
                                                    '</form>' +
                                                '</div>' +
                                                '<div id="ServiceAreas_resultsTab" role="tabpanel" class="tab-pane"> ' +
                                                    '<div id="ServiceAreas_ResultsListContainer"></div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>';

    export default class ServiceAreas {
      constructor() {
        $(".cv-responsiveBottomBar").append(responsiveBtn);
        $(".cv-left-top-pane").append(responsiveViewContainer);
        $(".cv-right-top-pane").append(genericView);
        $(".cv-alignBottom").before(btnToggleGenericView);
        window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
        window.cartovista.addOneTimeEventListener(C.LAYERS.SERVICE_AREAS.LAYER_ID + "_layerCreated", this._onServiceAreasLayerCreated, this);

        this._$container = $(serviceAreasContainerHtml);
        _.forEach(this._$container.find('[data-bs-toggle="popover"]'), function(popover){
          new Popover(popover, {
            placement: function() { return DomUtil.isResponsiveUI() ? "right" : "left"; }
          });
        });
        this._$resultsCountContainer = this._$container.find("#ServiceAreas_resultsCount");
        this._$form = this._$container.find("#ServiceAreas_form");
        this._formIsSubmitting = false;
        this._$sourceTypeInput = this._$form.find("#ServiceAreas_sourceTypeInput");
        this._sourceType = this._$sourceTypeInput.val();
        this._$mapTargetBtn = this._$form.find("#ServiceAreas_mapTargetBtn");
        this._$travelModeInput = this._$form.find("#ServiceAreas_travelModeInput");
        this._$travelModeInput = this._$form.find("#ServiceAreas_travelModeInput");
        this._$chkTraversiers = this._$form.find("#ServiceAreas_chkTraversiers");
        this._$travelModeInput.change(this._onTravelModeInputChanged.bind(this));
        this._$breakValuesInput = this._$form.find("#ServiceAreas_breakValuesInput");
        this._$breaksUnitInput = this._$form.find("#ServiceAreas_breaksUnitInput");
        this._$polygonForMultipleFacilitiesInput = this._$form.find("#ServiceAreas_polygonForMultipleFacilitiesInput");
        this._$polygonOverlapTypeInput = this._$form.find("#ServiceAreas_polygonOverlapTypeInput");
        this._$colorPaletteButton = this._$form.find("#ServiceAreas_colorPaletteBtn");
        this._$colorPaletteMenu = this._$form.find("#ServiceAreas_colorPaletteMenu");
        this._createColorPalettesStore();
        this._$submitBtn = this._$form.find("#ServiceAreas_submitBtn");
        this._$form.submit(this._onFormSubmitted.bind(this));
        this._$sourceTypeInput.change(this._onSourceTypeInputChanged.bind(this));
        this._$breakValuesInput.on("input", _.debounce(this._onBreakValuesInputChanged.bind(this), 250));
      }

      _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        this._mapController = window.cartovista.getMapController(this._map);
        $("#ServiceAreas_panel_btn").html('<span class="cv-icon cv-icon-isochroneIsodistance"></span>');
        $("#ServiceAreas_panel").html(this._$container);
        this._map = window.cartovista.externalInterface.map;
        this._map.addEventListener(this._map.EVENTS.SELECTION_CHANGED, this._enablePolygonForMultipleFacilitiesInput, this);
        this._mapController = window.cartovista.getMapController(this._map);
        this._mapTarget = new MapTarget(this._$mapTargetBtn[0], C.PANELS.SERVICE_AREAS.MAP_TARGET_DECORATION_STYLE);
        this._serviceAreaController = window.cartovista.getUIController(this._map).findInstance("ServiceAreas_panel")
        this._serviceAreaController.addEventListener(this._serviceAreaController.EVENTS.ACTIVATED, this._onPanelActivated, this);
        this._serviceAreaController.addEventListener(this._serviceAreaController.EVENTS.DEACTIVATED, this._onPanelDeactivated, this);
        window.cartovista.resizeRightVerticalSplitter(325);
    };

    _onServiceAreasLayerCreated(evt) {
        this._serviceAreasLayer = this._map.getLayer(C.LAYERS.SERVICE_AREAS.LAYER_ID);
        this._serviceAreasDataTable = this._serviceAreasLayer.getDataTable(C.LAYERS.SERVICE_AREAS.DATATABLE_ID);
        this._resultsList = new ServiceAreasResultsList(this._$container.find("#ServiceAreas_ResultsListContainer"), this._serviceAreasLayer, this._serviceAreasDataTable, true);
        this._resultsList.addEventListener("ResultsList_resultAdded", this._onResulListCountChanged, this);
        this._resultsList.addEventListener("ResultsList_resultRemoved", this._onResulListCountChanged, this);
        window.cartovista.dispatchEvent(new DBxEvent("_onServiceAreasLayerCreated"));
    }

    _onPanelActivated(e) {
        if (this._sourceType == "MAP_TARGET") {
            this._mapTarget._toggleMapTargetVisibility(true);
        }
    };

    _onPanelDeactivated(e) {
        this._mapTarget._toggleMapTargetVisibility(false);
    };

    //TODO : séparer dans un nouveau module: ColorPalettesPicker
    _createColorPalettesStore() {
        var paletteFactory = new PaletteFactory();
        var colorPalettes = _.map(ColorPaletteEnum.COLOR_PALETTE_LIST.slice(0, 20), paletteFactory.getColorPalette.bind(paletteFactory));
        this._colorPalettesStore = {
            _items : _.sortBy(_.map(colorPalettes, this._createColorPaletteItem.bind(this)), "rgbaPalette.4.ole"),
            get items() {
                return this._items;
            },
            getColorPaletteItem : function(colorPaletteId) {
                return _.find(this.items, {"colorPaletteId" : colorPaletteId});
            },
            getPopoverContentHtml : function() {
                return _.flatMap(_.chunk(this.items, 3), function(chunkedItems, idx) {
                    return '<div class="row">' +
                                _.map(chunkedItems, function(item) {
                                    return '<div class="col-md-4">' +
                                                '<a href="javascript:void(0);">' +
                                                    _.map(item.paletteHtml).join("") +
                                                '</a>' +
                                            '</div>';
                                }).join("") +
                                (idx == Math.floor(this.items.length/3) ?
                                    '<div class="col-md-4 text-center">' +
                                        '<a href="javascript:void(0);">' +
                                            '<span class="ServiceAreas_colorPalette" palette="RANDOM" style="display:inline-block;">Aléatoire</span>' +
                                        '</a>' +
                                    '</div>' : '') +
                            '</div>';
                }.bind(this));
            }
        };
        new Popover(this._$colorPaletteButton, {
          "template": '<div class="ServiceAreas_colorPalette_popover popover" role="popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>',
          "container": "body",
          "content": this._colorPalettesStore.getPopoverContentHtml().join(""),
          "placement": "top",
          "html": true,
          "trigger":"manual",
          "sanitize": false
        });
        $("body").on("click", ".ServiceAreas_colorPalette_popover a", $.proxy(function(evt) {
            this._$colorPaletteButton.html(evt.currentTarget.innerHTML);
            Popover.getInstance(this._$colorPaletteButton).toggle();
        }, this));
        this._$colorPaletteButton.html(this._colorPalettesStore.getColorPaletteItem("GREEN_YELLOW").paletteHtml);
        this._$colorPaletteButton.click(function() {
            Popover.getInstance(this._$colorPaletteButton).toggle();
        }.bind(this));

    };

    _createColorPaletteItem(colorPalette) {
        return {
            _colorPaletteId : colorPalette.colorPaletteEnum,
            _rgbaPalette : _.map(colorPalette.getColors(5), function(colorInt) { return new RGBA(colorInt); }),
            get paletteHtml() {
                return  '<span class="ServiceAreas_colorPalette" palette="' + this.colorPaletteId + '">' +
                            '<span class="ServiceAreas_colorPaletteRow">' +
                                _.map(this._rgbaPalette, function(rgba) {
                                    return '<span class="ServiceAreas_colorPaletteCell" style="background-color:' + rgba.rgba + ';"></span>';
                                }).join("") +
                            '</span>' +
                        '</span>';
            },
            get colorPaletteId() {
                return this._colorPaletteId;
            },
            get rgbaPalette() {
                return this._rgbaPalette;
            }
        };
    };

    _onSourceTypeInputChanged(e) {
        this._sourceType = this._$sourceTypeInput.val();
        this._$mapTargetBtn.parent().toggle();
        this._mapTarget.toggleOff();
        this._enablePolygonForMultipleFacilitiesInput();
        this._mapTarget._toggleMapTargetVisibility((this._sourceType == "MAP_TARGET"));
    };

    _onTravelModeInputChanged(e) {
        this._$breaksUnitInput.find("optgroup#TIME").prop('disabled', this._$travelModeInput.val() == "WALK");
        this._$chkTraversiers.prop('disabled', this._$travelModeInput.val() == "WALK");
    };

    _enablePolygonForMultipleFacilitiesInput(e) {
        this._map.selectionLayer.computeSelectionStack(function(linkingIds){
            if (this._sourceType === "SELECTION" && this._map.selectionLayer.layerType === "POINT" && linkingIds.length > 1) {
                this._$polygonForMultipleFacilitiesInput.prop("disabled", false);
            } else {
                this._$polygonForMultipleFacilitiesInput.prop("disabled", true);
            }
        }.bind(this));
    };

    _onBreakValuesInputChanged(e) {
        if (this._getBreakValuesArray().length > 1) {
            this._$polygonOverlapTypeInput.prop("disabled", false);
        } else {
            this._$polygonOverlapTypeInput.prop("disabled", true);
        }
    };

    _onFormSubmitted(e) {
        e.preventDefault();
        if (!this._formIsSubmitting) {
            switch (this._sourceType) {
                case "MAP_TARGET":
                    if (this._mapTarget._decoration._created) {
                        this._makeServiceAreasRequest();
                    } else {
                        show("ServiceAreas_mapTargetNotCreated");
                    }
                    break;
                case "SELECTION":
                    this._map.selectionLayer.computeSelectionStack(function(linkingIds){
                        if (this._map.selectionLayer.layerType === "POINT" && linkingIds.length) {
                            this._makeServiceAreasRequest();
                        } else {
                            show("ServiceAreas_noPointFeaturesSelected");
                        }
                    }.bind(this));
                    break;
                default:
                    throw new Error("ServiceAreas._onFormSubmitted() - this._sourceType: " + this._sourceType + " is invalid.");
            };
        } else {
            show("ServiceAreas_formIsSubmitting");
        }
    };

    _makeServiceAreasRequest() {
        var breakValues = this._getBreakValuesArray();
        if (breakValues.length) {
            if (breakValues.length > 5) {
                show("ServiceAreas_over5BreakValuesWarning");
            }
            this._$breakValuesInput.parent().removeClass("has-error");
            if(this._sourceType === "SELECTION"){
                this._getSelectedFeaturesData(breakValues);
            } else{ this._getMapTargetFeaturesData(breakValues); }
        } else {
            this._$breakValuesInput.parent().addClass("has-error");
            show("ServiceAreas_noOrInvalidBreakValues");
        }
    };

    _getSelectedFeaturesResults(queryResult, breakValues, result) {
        var features = _.map(result.features, function(feature, idx) {
            return {
                "attributes" : {
                    "Name" : queryResult.values[this._map.selectionLayer.featureNameDataColumn.dataTable.id][this._map.selectionLayer.featureNameDataColumn.id][idx]
                },
                "geometry" : {
                    "x" : feature.currentGeometry.coordinates[0][0].coordinates[0],
                    "y" : feature.currentGeometry.coordinates[0][0].coordinates[1]
                }
            };
        }.bind(this));
        var facilitiesData = this._getFacilitiesData(features);
        this._callRequest(facilitiesData, breakValues);
    };

    _callRequest(facilitiesData, breakValues) {
        var breakUnits = this._$breaksUnitInput.find("option:selected").val(),
            breakUnitsName = this._$breaksUnitInput.find("option:selected").attr("name"),
            polygonForMultipleFacilities = this._$polygonForMultipleFacilitiesInput.find("option:selected").val(),
            polygonOverlapType = this._$polygonOverlapTypeInput.find("option:selected").val(),
            travelMode = this._$travelModeInput.find("option:selected").val(),
            traversiersSaisonniers = this._$chkTraversiers.prop('checked');
        show("ServiceAreas_requestSubmitted");
        this._formIsSubmitting = true;
        serviceAreas(facilitiesData, _.slice(breakValues, 0, 5), breakUnits, polygonForMultipleFacilities, polygonOverlapType, travelMode, traversiersSaisonniers)
            .then(this._onRequestSuccess.bind(this))
            .catch(this._onRequestError.bind(this));
    };

    _getFacilitiesData(features) {
        return {
            "geometryType" : "esriGeometryPoint",
            "spatialReference" : {"wkid" : 3857},
            "fields" : [
                {
                    "name" : "Name",
                    "type" : "esriFieldTypeString"
                }
            ],
            "features" : features
        };
    };

    _getSelectedFeaturesData(breakValues) {
        return this._map.selectionLayer.computeSelectionStack(function(linkingIds){
            if (linkingIds.length > 3) {
                show("ServiceAreas_over3SelectedFeaturesWarning");
            }
            return new DataQuery([this._map.selectionLayer.featureNameDataColumn], _.slice(linkingIds, 0, 3))
                .execute(function(queryResult) {
                    this._map.selectionLayer.getSimpleFeatures(_.slice(linkingIds, 0, 3), this._getSelectedFeaturesResults.bind(this, queryResult, breakValues), this);
                }, this);
        }.bind(this));
    };

    _getMapTargetFeaturesData(breakValues) {
        var features = [{
                "attributes" : {
                    "Name" : "MAP_TARGET"
                },
                "geometry" : {
                    "x" : this._mapTarget._decoration.geometry.coordinates[0][0].coordinates[0],
                    "y" : this._mapTarget._decoration.geometry.coordinates[0][0].coordinates[1]
                }
            }];
        var facilitiesData = this._getFacilitiesData(features);
        this._callRequest(facilitiesData, breakValues);
    };

    _getBreakValuesArray() {
        //split string at each spaces, commas and semicolons
        var breaks = _.split(this._$breakValuesInput.val(), new RegExp(/[ ,;]+/));
        //convert strings to integers values (float are rounded to floor and 0 are removed)
        return _.compact(_.map(breaks, _.toInteger));
    };

    _onRequestSuccess(response) {
        show("ServiceAreas_serviceSuccess");
        this._formIsSubmitting = false;
        this._createResultFeatures(response);
        //log onServiceAreasRequested success event on piwik
        try {
            dataLayer.push({'event':'onServiceAreasRequested', 'queryResult': C.APP_NAME + " - success"});
        } catch(error) {
            //piwik blocked by an add blocker
            window.ClientErrorsLogger.logPiwikError(error);
        }
    };

    _createResultFeatures(response) {
        var features = createFeatures(C.LAYERS.SERVICE_AREAS, response.features),
            paletteColorId = this._$colorPaletteButton.find(".ServiceAreas_colorPalette").attr("palette");
        if (paletteColorId != "RANDOM") {
            _.forEach(features, function(feature, idx) {
                feature.style.symbolizers[0].fillColor1 = this._colorPalettesStore.getColorPaletteItem(paletteColorId).rgbaPalette[idx%5];
            }.bind(this));
        }
        this._serviceAreasLayer.addFeatures(features);
        this._serviceAreasDataTable.addDataRows(createDataRows(C.LAYERS.SERVICE_AREAS, response.features, _.map(features, "id")));
        this._mapController.zoomOnFeatures(features, (features.length > 1 ? null : this._serviceAreasLayer), null, false);
        this._resultsList.addResult(features);
    };

    _onRequestError(error) {
        show("ServiceAreas_serviceError", {"error" : error});
        this._formIsSubmitting = false;
        //log onServiceAreasRequested error event on piwik
        try {
            dataLayer.push({'event':'onServiceAreasRequested', 'queryResult': C.APP_NAME + " - error"});
        } catch(error) {
            //piwik blocked by an add blocker
            window.ClientErrorsLogger.logPiwikError(error);
        }
    };

    _onResulListCountChanged(evt) {
        this._$resultsCountContainer.html(this._resultsList.count ? "(" + this._resultsList.count + ")" : "");
    };

}
